import { createRouter, createWebHistory } from "vue-router";

import { useAuthStore } from "../features/auth/auth-store.js";

declare module "vue-router" {
  interface RouteMeta {
    /** 未登录也能访问的页面。默认所有页面都需要登录。 */
    public?: boolean;
  }
}

/**
 * 路由。
 *
 * 默认**所有页面都需要登录**，只有显式标了 `public` 的除外：后台能改价格与库存，
 * 漏标一处就会开出一个免登录页面，默认收紧更安全。
 *
 * 刷新页面时先向服务端确认会话（`restore`），确认不了就回登录页——本地存着令牌
 * 不等于这个令牌还有效。
 */
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("../features/auth/LoginPage.vue"),
      meta: { public: true },
    },
    {
      path: "/",
      component: () => import("../layouts/AdminLayout.vue"),
      children: [
        {
          path: "orders",
          name: "orders",
          component: () => import("../features/orders/OrdersView.vue"),
        },
        {
          path: "shipping",
          name: "shipping",
          component: () => import("../features/shipping/ShippingView.vue"),
        },
        { path: "", redirect: { name: "stones" } },
        {
          path: "stones",
          name: "stones",
          component: () => import("../features/catalog/StoneListView.vue"),
        },
        {
          path: "works",
          name: "works",
          component: () => import("../features/works/WorkListView.vue"),
        },
        {
          path: "home",
          name: "home",
          component: () => import("../features/content/HomeContentView.vue"),
        },
        {
          path: "accounts",
          name: "accounts",
          component: () => import("../features/auth/AccountView.vue"),
        },
      ],
    },
  ],
});

router.beforeEach(async (to) => {
  if (to.meta.public === true) {
    return true;
  }

  const auth = useAuthStore();
  if (auth.isAuthenticated) {
    return true;
  }

  const restored = await auth.restore();
  if (restored) {
    return true;
  }
  return { name: "login", query: { redirect: to.fullPath } };
});
